import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactComponent {

	public getYear() {

		const date = new Date();
		return date.getFullYear().toString();
	}
}
